"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _loveButton = _interopRequireDefault(require("../loveButton.js"));

var _fullscreenSocialDownload = _interopRequireDefault(require("../fullscreenSocialDownload.js"));

var _utils = require("../../utils");

var _fullscreenCartIcon = _interopRequireDefault(require("../fullscreenCartIcon.js"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash"));

var _shareStore = _interopRequireDefault(require("-!svg-react-loader!../../assets/images/fullscreen-store/share-store.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenMobileBarV2 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenMobileBarV2, _React$Component);

  function FullscreenMobileBarV2(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      showShare: false
    };
    _this.sampleInput = {
      love: {
        onClick: function onClick() {},
        text: '1'
      }
    };
    return _this;
  }

  var _proto = FullscreenMobileBarV2.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    var _this2 = this;

    if (_utils.utils.isStoreGallery()) {
      var providerId = _utils.utils.getProviderFromGalleryInfo(newProps.galleryInfo);

      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@wix/pro-gallery-artstore-statics'));
      }).then(function (cart) {
        cart.cartApi.getCartItems(providerId).then(function (arrItems) {
          var count = cart.cartApi.getCartItemsCount(arrItems);

          _this2.setState({
            cartItemsCount: count
          });
        });
      });
    }
  };

  _proto.getLoveButton = function getLoveButton() {
    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        love = _this$props.love;

    var props = _lodash["default"].pick(this.props, ['itemId', 'id', 'item', 'idx', 'styleParams', 'love', 'hashtag', 'actions']);

    return styleParams.loveButton ? _react["default"].createElement(_loveButton["default"], _extends({}, props, {
      layout: "fullscreen",
      device: "mobile",
      showCounter: true
    })) : '';
  };

  _proto.getDownloadButton = function getDownloadButton() {
    var _this$props2 = this.props,
        current = _this$props2.current,
        styleParams = _this$props2.styleParams;
    return _react["default"].createElement(_fullscreenSocialDownload["default"], {
      layout: "fullscreen",
      device: "mobile",
      current: current,
      styleParams: styleParams,
      itemActions: this.props.actions.itemActions
    });
  };

  _proto.getCartButton = function getCartButton() {
    return _utils.utils.isStoreGallery() ? _react["default"].createElement(_fullscreenCartIcon["default"], {
      cartItemsCount: this.state.cartItemsCount
    }) : false;
  };

  _proto.getShareContainer = function getShareContainer() {
    var _this3 = this;

    var shareButton = this.props.styleParams.allowSocial ? _react["default"].createElement("button", {
      className: "pro-fullscreen-share-icon",
      onClick: function onClick() {
        return _this3.props.actions.toggleShareScreen();
      }
    }, (0, _shareStore["default"])()) : // <i className='progallery-svg-font-icons-share-store pro-fullscreen-share-icon' onClick={() => this.props.actions.toggleShareScreen()}/>
    false;
    return _react["default"].createElement("div", {
      className: "fullscreen-social"
    }, this.getDownloadButton(), this.getCartButton(), this.getLoveButton(), shareButton);
  };

  _proto.getTopMobileBar = function getTopMobileBar() {
    var _this4 = this;

    var mobileTopClassNames = (0, _classnames["default"])('fullscreen-mobile-bar', 'fullscreen-mobile-top', 'pro-fullscreen-store', 'fixed-items', {
      share: this.state.showShare
    });
    return _react["default"].createElement("div", {
      className: mobileTopClassNames
    }, _react["default"].createElement("div", null, _react["default"].createElement("button", {
      className: "fullscreen-close progallery-svg-font-icons-back",
      onClick: function onClick() {
        return _this4.props.actions.close(_this4.props.current.idx);
      }
    }), this.getShareContainer()));
  };

  _proto.render = function render() {
    var mobileBars = [];

    if (_utils.utils.isSmallScreen()) {
      mobileBars[0] = this.getTopMobileBar();
      mobileBars[1] = false;
    }

    var res = this.props.isFirst ? mobileBars[0] || false : mobileBars[1] || false;
    return res;
  };

  return FullscreenMobileBarV2;
}(_react["default"].Component);

var _default = FullscreenMobileBarV2;
exports["default"] = _default;